module.exports = __webpack_public_path__ + "img/u187.60d9d6c9.png";